import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { logError } from '../../lib/logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RoadTo53Promo = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/roster/tracker`)
      .then((r) => setData(r.data))
      .catch((error) => logError('road to 53 promo failed:', error));
  }, []);

  if (!data || !data.players?.length) return null;
  const { counts, players, changes = [], transactions = [], settings } = data;
  const bubbleCount = players.filter((p) => p.classification === 'BUBBLE').length;

  let tidbit = null;
  if (bubbleCount > 0) tidbit = `${bubbleCount} player${bubbleCount === 1 ? '' : 's'} currently on the bubble`;
  else if (transactions.length > 0) tidbit = `${transactions.length} recent roster move${transactions.length === 1 ? '' : 's'}`;
  else if (changes.length > 0) tidbit = 'Tracker updated recently';

  const isFinal = settings?.phase === 'final';
  const lastUpdated = settings?.last_updated
    ? new Date(settings.last_updated).toLocaleString('en-US', {
        month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York',
      }) + ' ET'
    : null;

  return (
    <section data-testid="road-to-53-promo" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8">
      <div className="bg-[#5A1414] border-l-4 border-[#FFB612]">
        <div className="px-5 sm:px-8 py-5 flex flex-col md:flex-row md:items-center gap-5">
          <div className="flex-1 min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#FFB612]">Commanders Roster & Cut Tracker</p>
            <h2 className="font-heading text-lg md:text-lg text-white uppercase tracking-wide mt-1">
              {isFinal ? 'Final 53-Man Roster' : 'Road to 53'}
            </h2>
            <p className="text-white/75 text-sm mt-1">
              Follow Washington's roster battle as the Commanders work toward the final 53.
              {tidbit && <span className="text-[#FFB612] font-semibold"> {tidbit}.</span>}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5 shrink-0">
            <div className="grid grid-cols-3 sm:flex gap-4 text-center">
              <div data-testid="promo-current-roster">
                <p className="font-heading text-xl text-white">{counts.active}</p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-white/60">Current Roster</p>
              </div>
              <div data-testid="promo-projected-53">
                <p className="font-heading text-xl text-[#FFB612]">{counts.projected}/53</p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-white/60">Projected 53</p>
              </div>
              <div data-testid="promo-bubble-count">
                <p className="font-heading text-xl text-white">{bubbleCount}</p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-white/60">On the Bubble</p>
              </div>
              <div data-testid="promo-cut-count" className="hidden sm:block">
                <p className="font-heading text-xl text-white">{counts.officially_out ?? 0}</p>
                <p className="text-[9px] font-bold uppercase tracking-wide text-white/60">Cut / Released</p>
              </div>
            </div>
            <Link
              to="/commanders#road-to-53"
              data-testid="view-road-to-53-btn"
              className="inline-flex items-center justify-center gap-2 bg-white text-[#5A1414] px-4 py-2.5 font-heading font-medium text-xs uppercase tracking-wide hover:bg-[#FFB612] transition-colors"
            >
              <Users className="w-4 h-4" />
              View Road to 53 Tracker
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
        <div className="px-5 sm:px-8 pb-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-white/50 text-[11px]">
          {!isFinal && <span>Next cutdown deadline: Sunday, Aug 30, 2026 · 6:00 PM ET</span>}
          {lastUpdated && <span data-testid="promo-last-updated">Last updated: {lastUpdated}</span>}
        </div>
      </div>
    </section>
  );
};

export default RoadTo53Promo;
